import {Card, Grid} from "@mui/material";
import CardBody from "../../../card/cardBody";
import Badge from "../../../Badge";
import {black500, blueColor, greyishBlue50, greyishBlue500} from "../../../../assets/jss/main";
import PropTypes from "prop-types";
import {FormattedDate, FormattedMessage} from "react-intl";
import React from "react";
import WMSCarrierIcon from "../../WMSCarrierIcon";
import {ImageSharp} from "@mui/icons-material";

WmsItemWithOrder.propsTypes = {
    numOrder: PropTypes.number.isRequired,
    description: PropTypes.string.isRequired,
    badges: PropTypes.array,
    icon: PropTypes.string,
    iconAlt: PropTypes.string,
    thumbnailSource: PropTypes.string,
    thumbnailAlt: PropTypes.string,
    isMulti: PropTypes.bool,
    multiShipment: PropTypes.bool,
    shipmentCount: PropTypes.element,
    isPackedShipment: PropTypes.bool,
    orderCreatedAt: PropTypes.string
}

/**
 * WmsItemWithOrder component
 * @returns {JSX.Element}
 */
export default function WmsItemWithOrder({numOrder, description, badges, icon, iconAlt, thumbnailSource, thumbnailAlt, shipmentCount, isPackedShipment, isMulti = false, multiShipment = false, orderCreatedAt}) {
    const thumbnailSize = '40px';
    const iconSize = '16px';

    return (
        <Card style={{height: 'fit-content', border: isPackedShipment ? "1px solid" : "none", borderColor: isPackedShipment ? "red" : "none"}}>
            <CardBody style={{
                padding: '0 16px',
                height: '100%',
            }}>
                <Grid
                    container
                    direction={"row"}
                    height={"100%"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    wrap={"nowrap"}
                >
                    <Grid
                        container margin={0}
                        direction={"row"}
                        alignItems={"center"}
                        wrap={"nowrap"}
                        width={"100%"}
                    >
                        {thumbnailSource && thumbnailAlt && !isMulti &&
                             <img
                                 src={thumbnailSource}
                                 alt={thumbnailAlt}
                                 style={{
                                     width: thumbnailSize,
                                     height: thumbnailSize,
                                     border: '1px solid ' + greyishBlue50,
                                     borderRadius: '8px',
                                     marginRight: '16px',
                                 }}
                             />
                        }

                        {!thumbnailSource && !isMulti && (
                            <span style={{marginRight: '16px', border: '1px solid ' + greyishBlue50, borderRadius: '8px'}}>
                                <ImageSharp color={"disabled"} sx={{fontSize: '40px'}}/>
                            </span>

                        )}
                        <Grid container direction={isMulti && badges.length === 1 ? "row" : "column"} justifyContent={isMulti && badges.length === 1 ? "space-between" : 'center'} sx={{paddingY: '16px'}}>
                            <Grid container direction={"column"} sx={{width: 'fit-content'}}>
                                <span
                                    style={{
                                        color: greyishBlue500,
                                        fontSize: "12px",
                                        fontWeight: 400
                                    }}>
                                {isMulti ?
                                    <FormattedMessage id={"wms.packing.shipmentItem.description.isMulti"}/> :
                                    <FormattedMessage id={"wms.packing.shipmentItem.description.isMono"}/>
                                }
                                    {description}
                                </span>
                                <div
                                    style={{
                                        fontWeight:600,
                                        fontSize: "12px"
                                    }}>
                                <span style={{color: blueColor}}>
                                    {numOrder}
                                </span>
                                    {multiShipment && (
                                        <span>
                                        &nbsp;•&nbsp;<FormattedMessage id={"wms.shipping.label"}/> {shipmentCount}
                                    </span>
                                    )}
                                </div>
                            </Grid>
                            <Grid container alignItems={"center"} sx={{marginTop: isMulti && badges.length === 1 ? '8px' : '16px', width: 'fit-content', marginRight: '8px'}} gap={'8px'}>
                                {orderCreatedAt && (
                                    <span style={{color: greyishBlue500, fontSize: "12px", fontWeight: 400, whiteSpace: "nowrap"}}>
                                        <FormattedDate value={new Date(orderCreatedAt)} year={"numeric"} month={"numeric"} day={"numeric"}/>
                                    </span>
                                )}
                                {badges && badges.length > 0 && badges.map(container => {
                                    return (
                                        <div>
                                            <Badge
                                                isBold={false}
                                                label={isMulti ? (container.hiveName ? `${container.hiveName} • ${container.name}` : container.name) : container.name}
                                                size={"large"}
                                                color={"default"}
                                            />
                                        </div>
                                    )
                                })}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        width={"fit-content"}
                    >
                        {icon && iconAlt && (
                            <WMSCarrierIcon
                                iconName={icon}
                                altName={iconAlt}
                                width={iconSize}
                                height={iconSize}
                            />
                        )}
                    </Grid>
                </Grid>
            </CardBody>
        </Card>

    );
}
